import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../lib/AuthContext";
import { Lock } from "lucide-react";
import { toast } from "sonner";

function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

const AdminLogin = () => {
  const { user, login, loading } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (!loading && user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await login(email.trim(), password);
      toast.success("Welcome back.");
      navigate("/admin", { replace: true });
    } catch (err) {
      toast.error(formatApiErrorDetail(err?.response?.data?.detail) || "Login failed");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-[80vh] grid grid-cols-1 lg:grid-cols-2">
      <div className="hidden lg:block bg-[#0F1245] text-white relative">
        <div className="absolute inset-0 grain" />
        <div className="relative h-full p-16 flex flex-col justify-between">
          <div className="overline" style={{ color: "#B7E4F4" }}>Admin Console</div>
          <div>
            <h2 className="font-serif-display text-5xl xl:text-6xl font-light leading-[1.05]">
              Manage the<br />season&apos;s <span className="italic text-[#B7E4F4]">collection</span>.
            </h2>
            <p className="text-white/50 mt-6 max-w-md text-[14px] leading-relaxed">
              Add new pieces, refresh the catalogue PDF and keep the lookbook in sync with the warehouse.
            </p>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-center p-8 md:p-16">
        <form onSubmit={submit} className="w-full max-w-sm" data-testid="admin-login-form">
          <Lock size={22} strokeWidth={1.5} className="text-[#4A3FCF]" />
          <h1 className="font-serif-display text-4xl mt-6">Admin sign in</h1>
          <p className="text-[14px] text-[#5A5F7A] mt-2">Restricted area for the Style India Delhi team.</p>

          <div className="mt-10 space-y-1">
            <label className="overline">Email</label>
            <input data-testid="admin-email" className="line-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="admin@styleindiadelhi.com" />
          </div>
          <div className="mt-6 space-y-1">
            <label className="overline">Password</label>
            <input data-testid="admin-password" className="line-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" />
          </div>

          <button data-testid="admin-login-submit" disabled={submitting} className="btn-primary mt-10 w-full justify-center">
            {submitting ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
